import { LightBulbIcon } from '@heroicons/react/24/outline';
export const BrainIcon = LightBulbIcon;
